"use strict";
/**
 * Financial Report Models
 *
 * These interfaces define the structure of all financial reports generated by the reports Lambda.
 * All reports are scoped by ownerId and buildingId for multi-tenancy.
 */
Object.defineProperty(exports, "__esModule", { value: true });
